import { default as _91_46_46_46404_9303gpwb8twOMeta } from "/home/runner/work/gift-nuxt/gift-nuxt/pages/[...404].vue?macro=true";
import { default as cartwBYQFd2sWJMeta } from "/home/runner/work/gift-nuxt/gift-nuxt/pages/cart.vue?macro=true";
import { default as checkout08Gp3hxsxaMeta } from "/home/runner/work/gift-nuxt/gift-nuxt/pages/checkout.vue?macro=true";
import { default as _91id_93Og6i3KTsyJMeta } from "/home/runner/work/gift-nuxt/gift-nuxt/pages/collections/[id].vue?macro=true";
import { default as indexowlVWaz6FbMeta } from "/home/runner/work/gift-nuxt/gift-nuxt/pages/index.vue?macro=true";
import { default as _91page_933gkIxb0HXjMeta } from "/home/runner/work/gift-nuxt/gift-nuxt/pages/pages/[page].vue?macro=true";
import { default as _91sku_93WhwuROq7utMeta } from "/home/runner/work/gift-nuxt/gift-nuxt/pages/products/[sku].vue?macro=true";
import { default as _91order_id_9306AEHLC9olMeta } from "/home/runner/work/gift-nuxt/gift-nuxt/pages/success/[order_id].vue?macro=true";
export default [
  {
    name: "404",
    path: "/:404(.*)*",
    component: () => import("/home/runner/work/gift-nuxt/gift-nuxt/pages/[...404].vue")
  },
  {
    name: "cart",
    path: "/cart",
    component: () => import("/home/runner/work/gift-nuxt/gift-nuxt/pages/cart.vue")
  },
  {
    name: "checkout",
    path: "/checkout",
    meta: checkout08Gp3hxsxaMeta || {},
    component: () => import("/home/runner/work/gift-nuxt/gift-nuxt/pages/checkout.vue")
  },
  {
    name: "collections-id",
    path: "/collections/:id()",
    component: () => import("/home/runner/work/gift-nuxt/gift-nuxt/pages/collections/[id].vue")
  },
  {
    name: "index",
    path: "/",
    component: () => import("/home/runner/work/gift-nuxt/gift-nuxt/pages/index.vue")
  },
  {
    name: "pages-page",
    path: "/pages/:page()",
    component: () => import("/home/runner/work/gift-nuxt/gift-nuxt/pages/pages/[page].vue")
  },
  {
    name: "products-sku",
    path: "/products/:sku()",
    component: () => import("/home/runner/work/gift-nuxt/gift-nuxt/pages/products/[sku].vue")
  },
  {
    name: "success-order_id",
    path: "/success/:order_id()",
    meta: _91order_id_9306AEHLC9olMeta || {},
    component: () => import("/home/runner/work/gift-nuxt/gift-nuxt/pages/success/[order_id].vue")
  }
]